import { snakeCase } from 'snake-case'

export const eventTracking = (event_category, event_action, event_label) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'event_tracking',
    event_category,
    event_action,
    event_label,
  })
}

export const purchaseTracking = (type, transaction_id) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'purchase',
    type,
    transaction_id,
  })
}

export const inputEfClickedTracking = (label) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'input_ef', // category
    item_name: 'click', // action
    item_value: label, // label
  })
  window.dataLayer.push({
    event: 'click_element',
    element_label: snakeCase(label),
  })
}

export const inputEfSelectedTracking = (label) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'input_ef', // category
    item_name: 'focus', // action
    item_value: label, // label
  })
  window.dataLayer.push({
    event: 'click_element',
    element_label: snakeCase(label),
  })
}

export const inputEfCompletedTracking = (label) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'input_ef', // category
    item_name: 'completed', // action
    item_value: label, // label
  })
}

export const inputEfCompletedAndBlurTracking = (label) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'input_ef', // category
    item_name: 'blur_completed', // action
    item_value: label, // label
  })
}

export const inputEfUncompletedAndBlurTracking = (label) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'input_ef', // category
    item_name: 'blur_uncompleted', // action
    item_value: label, // label
  })
}

export const productTransactionTracking = (transaction, products = []) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    transactionId: '',
    transactionAffiliation: 'lifedot',
    transactionTotal: 0,
    transactionShipping: 0,
    transactionTax: 0,
    transactionProducts: products,
    ...transaction,
  })
}

export const optimizeTracking = (eventName) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName,
  })
}
